import './App.css';
import { useEffect, useState } from 'react';
import Tabs from '@Generator/tabs/Tabs';
import {
  Brain,
  ClockCounterClockwise,
  Ticket,
  Image,
  Sparkle,
} from '@phosphor-icons/react';
import { GeneratorContextProvider } from '@Context/GeneratorContext';
import { TestCaseContextProvider } from '@Context/TestCaseContext';
import Tab from '@Generator/tabs/Tab';
import Generate from '@Generator/create';
import Queue from '@Generator/create/Tasks/Queue';
import History from '@Generator/history';
import Tickets from '@Generator/tickets';
import ImageAnalyzer from '@Generator/image-analyzer/ImageAnalyzer';
import ImageGenerator from '@Generator/image-generator/ImageGenerator';
import SidePanelButton from '@Common/SidePanelButton';
import { TicketContextProvider } from '@Context/TicketContext';
import SidePanelWrapper from '@Generator/testcases';
import { QueueContextProvider } from '@Context/QueueContext';
import { useAuth } from '@Context/CognitoAuthProvider';
import { UserClassification } from '@Models/types';
import { getUserClassification } from '@Utils/typeguards';
import WrapperTabPanel from '@Generator/tabs/WrapperTabPanel';
import ScrollableTabPanel from '@Generator/tabs/ScrollableTabPanel';

const App = () => {
  const [newUser, setNewUser] = useState<UserClassification>('none');
  const { user } = useAuth();

  useEffect(() => {
    setNewUser(getUserClassification(user));
  }, [user]);

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <div className="relative flex h-full w-full flex-col">
        <TestCaseContextProvider>
          <QueueContextProvider>
            <GeneratorContextProvider>
              <Tabs>
                <div
                  id="tab-list"
                  className="flex flex-col items-center gap-y-2 rounded-xl bg-neutral-200 p-4 sm:flex-row sm:justify-between"
                  // flex-row items-center justify-between
                >
                  <div className="flex flex-row">
                    <Tab
                      index={0}
                      label="Test Cases"
                      icon={<Brain size={25} />}
                    />
                    <Tab
                      index={1}
                      label="Image Analyzer"
                      icon={<Image size={25} />}
                    />
                    <Tab
                      index={2}
                      label="History"
                      icon={<ClockCounterClockwise size={25} />}
                    />
                    <Tab
                      index={3}
                      label="Tickets"
                      icon={<Ticket size={25} />}
                    />
                    <Tab
                      index={5}
                      label="Image Generator"
                      icon={<Sparkle size={25} />}
                    />
                    {/*temp button for experimental jira integration */}
                  </div>

                  <Queue />
                </div>
                <WrapperTabPanel
                  index={0}
                  requiredKeys={['jira', 'testrail']}
                  userType={newUser}
                >
                  <Generate />
                </WrapperTabPanel>

                <WrapperTabPanel
                  index={1}
                  requiredKeys={['jira', 'testrail']}
                  userType={newUser}
                >
                  <ImageAnalyzer />
                </WrapperTabPanel>

                <WrapperTabPanel
                  index={2}
                  requiredKeys={['jira', 'testrail']}
                  userType={newUser}
                >
                  <History />
                </WrapperTabPanel>

                <WrapperTabPanel
                  index={3}
                  requiredKeys={['jira']}
                  userType={newUser}
                  jiraOnly={true}
                >
                  <TicketContextProvider>
                    <Tickets />
                  </TicketContextProvider>
                </WrapperTabPanel>

                <ScrollableTabPanel index={5}>
                  <ImageGenerator />
                </ScrollableTabPanel>
              </Tabs>

              <SidePanelButton />
              <SidePanelWrapper />
            </GeneratorContextProvider>
          </QueueContextProvider>
        </TestCaseContextProvider>
      </div>
    </div>
  );
};

export default App;
